<script>
import baseMixin from '@mixins/baseMixin'
import { mapGetters } from 'vuex'
import routeDefinitions from '@/shared/constants/routes/routeDefinitions'

export default {
  name: 'NavDrawerActionButton',
  mixins: [baseMixin],
  props: {
    mobileView: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters({
      mini: 'isDrawerOpen',
    }),
    buttons() {
      return [
        {
          name: 'settings',
          icon: 'mdi-cog-outline',
          label: this.$t('settings.pageTitle'),
          route: routeDefinitions.settings.name,
        },
        {
          name: 'help',
          icon: 'mdi-help-circle-outline',
          label: this.$t('help.pageTitle'),
          route: routeDefinitions.help.name,
        },
      ]
    },
  },
  methods: {
    isActiveRoute(baseName) {
      return this.$route.path.startsWith(`/${baseName}`)
    },
    goTo(routeName) {
      this.$router.push({ name: routeName })
    },
  },
}
</script>

<template>
  <!-- Desktop view -->
  <div v-if="!mobileView" class="text-start">
    <v-tooltip v-for="btn in buttons" :key="btn.name" :disabled="!mini" right>
      <template v-slot:activator="{ on }">
        <BaseButton
          :class="[
            'pa-4 mx-auto d-flex rounded-lg align-center justify-start nav-btn hover-bg-color',
            isActiveRoute(btn.name) && 'nav-active',
            mini && 'nav-btn-mini',
          ]"
          :style="mini ? 'padding:6px!important;' : 'margin:0 10px!important;'"
          color="white"
          hover-color="blue400"
          :border-radius="'8px'"
          :width="'204'"
          :height="'48'"
          @click="goTo(btn.name)"
          v-on="on"
        >
          <v-icon :style="mini ? '' : 'margin-right:16px;'">{{
            btn.icon
          }}</v-icon>
          <span v-if="!mini" style="font-weight: 600">{{ btn.label }}</span>
        </BaseButton>
      </template>
      <span>{{ btn.label }}</span>
    </v-tooltip>
  </div>

  <!-- Mobile view -->
  <div v-else class="px-4 pt-2 pb-1 d-flex flex-column text-start">
    <BaseButton
      v-for="btn in buttons"
      :key="btn.name"
      :class="[
        'pa-7 py-4 mx-auto d-flex rounded-lg align-center justify-start action-btn',
        isActiveRoute(btn.name) && 'nav-active',
      ]"
      style="padding-left: 10px !important"
      color="white"
      hover-color="blue400"
      :border-radius="'8px'"
      :width="'100%'"
      :height="'48'"
      @click="goTo(btn.name)"
    >
      <v-icon size="20" style="margin-right: 16px">{{ btn.icon }}</v-icon>
      <span style="font-weight: 500">{{ btn.label }}</span>
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
@import '@styles';
@import '@/styles/nav-drawer.scss';

.v-icon {
  color: $color-neutral-grey-400 !important;
}

.nav-active {
  color: $color-blue-500 !important;
  background-color: $color-info-250 !important;

  .v-icon {
    color: $color-blue-400 !important;
  }
}

.action-btn {
  color: $color-gray-600 !important;

  &:hover {
    color: $color-blue-500;
    background-color: $color-info-250;

    .v-icon {
      color: $color-blue-400 !important;
    }
  }
}
</style>
